export default function getTimelineDuration(scenes) {
  const sceneList = Object.values(scenes)
  return sceneList.reduce(
    (accumulator, currentValue) => accumulator + currentValue.duration,
    0,
  )
}
